<template>
  <div>

    <h2>Notifications</h2>
    <table>
      <tr>
        <td valign="top">Enabled:</td>
        <td>
          <label class="switch">
            <input type="checkbox" v-model="notifications">
            <span class="slider round"></span>
          </label>
        </td>
      </tr>
      <tr>
        <td valign="top">Emails:</td>
        <td>
          <div v-for="(email, index) in notificationEmails" :key="index">
            <input type="input" v-model="email.value" size="50">
          </div>
          <button @click="newNotificationEmail">Add</button>
        </td>
      </tr>
    </table>
    <button @click="cancel()">Cancel</button>
    <button @click="saveNotificationSettings()">Save</button>

    <h2>Support</h2>
    <label>
      Email: <input type="input" v-model="supportEmail" size="50">
    </label>
    <div class="hint">
      Support requests will be sent to this email. Also, it's added as reply to address for notification emails.
    </div>
    <br>
    <button @click="cancel()">Cancel</button>
    <button @click="saveSupportSettings()">Save</button>

    <pre class="debug" v-show="debugMode">{{ partner }}</pre>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hint {
  font-size: small;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  name: 'settingsPartner',
  data () {
    return {
      supportEmail: null,
      notifications: null,
      notificationEmails: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState([
      'partnerMode',
      'accountMode',
      'debugMode',
      'partner'
    ])
  },
  watch: {
    partner () {
      this.init()
    }
  },
  methods: {
    init () {
      if (!this.partner.settings) return
      this.supportEmail = this.partner.settings.support_email
      this.notifications = this.partner.settings.notifications
      this.initNotificationEmails()
    },
    initNotificationEmails () {
      this.notificationEmails = []
      for (var email in this.partner.settings.notification_emails) {
        this.notificationEmails.push({value: this.partner.settings.notification_emails[email]})
      }
    },
    getNotificationEmails () {
      var emails = []
      for (var email in this.notificationEmails) {
        if (this.notificationEmails[email].value)
          emails.push(this.notificationEmails[email].value)
      }
      return emails
    },
    newNotificationEmail () {
      this.notificationEmails.push({value: ''})
    },
    refreshSettings () {
      this.$store.dispatch('loadPartnerSettings')
    },
    cancel () {
      this.$store.dispatch('loadPartnerSettings')
    },
    saveSupportSettings () {
      if (!confirm('Are you sure? Partner notification settings will affect all accounts!')) return
      this.$store.dispatch('savePartnerSettings', {
        support_email: this.supportEmail
      })
    },
    saveNotificationSettings () {
      if (!confirm('Are you sure? Partner notification settings will affect all accounts!')) return
      this.$store.dispatch('savePartnerSettings', {
        notifications: this.notifications,
        notification_emails: this.getNotificationEmails()
      })
    }
  }
}
</script>
